import React from 'react';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { isNumber } from 'lodash';
import { spacing as muiSpacing } from '@mui/system';

import { GRID } from '../../constants';

import Box from './box';

const ROW_SPACING_STYLES = `
  margin-left: -${GRID.ROW_MARGIN};
  margin-right: -${GRID.ROW_MARGIN};
`;

const StyledRow = styled(Grid)`
  ${({ spacing }) => !isNumber(spacing) && ROW_SPACING_STYLES};

  ${muiSpacing}

  ${(props) =>
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'fillSpace' does not exist on type 'GridOwnProps & CommonProps & Omit<Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "ref"> & { ...; }, "xl" | ... 120 more ... | "zeroMinWidth"> & { ...; } & { ...; }'.
    props.fillSpace &&
    `
    ${Box} {
      flex: 1 1 auto;
      width: 100%;
    }
  `};

  &.MuiGrid-container {
    width: auto;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'className' implicitly has an 'any' type.
const Row = ({ className, children, spacing, ...props }) => (
  <StyledRow className={className} container spacing={spacing} {...props}>
    {children}
  </StyledRow>
);

export default Row;
